import { useTranslation } from 'react-i18next';
import { CommonCheckbox } from 'src/global/components/CommonCheckbox';
import * as Constants from '@global/App/constants/constants';
import { SiteConfig } from '@global/utils/SiteConfig';

export interface SubscriptionInfo {
  planName: string;
  billingPeriod: string;
  frequency: string;
  nextPaymentDate: string;
  currency_symbol: string;
  price: string;
  day: number;
}

interface TermsProps {
  toggle: () => void;
  checked: boolean;
  toggleProfessionalUse: () => void;
  professionalUseChecked: boolean;
  isAigateway: boolean;
  withRental: boolean;
  isSubscription: boolean;
  subscriptionInfo?: SubscriptionInfo;
}

export const Terms = ({
  toggle,
  checked,
  toggleProfessionalUse,
  professionalUseChecked,
  isAigateway,
  withRental,
  isSubscription,
  subscriptionInfo,
}: TermsProps) => {
  const { t, i18n } = useTranslation();
  const termsUrl = Constants.TERMS_URL.replace(':locale', i18n.language);
  const policyUrl = Constants.POLICY_URL.replace(':locale', i18n.language);
  const rentalTermsUrl = Constants.RENTAL_TERMS_URL.replace(
    ':locale',
    i18n.language
  );
  const { isSpectraBase } = SiteConfig.getConfig();

  const rentalCheckbox = (
    <>
      <p className="regular-text">
        {t('checkout.summary.terms&conditions.description')}
      </p>
      <CommonCheckbox toggle={toggle} checked={checked}>
        <span className="order-review__agreement--text">
          {t('checkout.summary.terms&conditions.instructions')}
          <a
            href={rentalTermsUrl}
            target="_blank"
            className="order-review__agreement--link"
            rel="noreferrer"
          >
            {t('checkout.summary.terms&conditions.link')}
          </a>
          {t('checkout.summary.terms&conditions.instructions2')}
        </span>
      </CommonCheckbox>
    </>
  );

  const subscriptionCheckbox = (
    <>
      <p className="regular-text">
        {t('checkout.summary.terms&conditions.description')}
      </p>
      <CommonCheckbox toggle={toggle} checked={checked}>
        <span className="order-review__agreement--text">
          {t(
            isAigateway
              ? 'checkout.summary.terms&conditions.aiGatewaySubscription'
              : isSpectraBase
              ? `checkout.summary.terms&conditions.spectraBaseSubscription.${subscriptionInfo.billingPeriod}`
              : 'checkout.summary.terms&conditions.subscription',
            subscriptionInfo
          )}
        </span>
      </CommonCheckbox>
      {isAigateway ? (
        <CommonCheckbox
          toggle={toggleProfessionalUse}
          checked={professionalUseChecked}
        >
          <span className="order-review__agreement--text">
            {t('checkout.summary.terms&conditions.aiGatewayProfessionalUse')}
          </span>
        </CommonCheckbox>
      ) : null}
    </>
  );

  return (
    <div className="order-review__agreement">
      {withRental ? rentalCheckbox : null}
      {isSubscription && subscriptionInfo ? subscriptionCheckbox : null}
      <p className="regular-text">
        {t('checkout.summary.terms&conditions.description2')}{' '}
        <a
          href={termsUrl}
          target="_blank"
          className="order-review__agreement--link"
          rel="noreferrer"
        >
          {t('checkout.summary.terms&conditions.termsLink')}
        </a>
        {t('checkout.summary.terms&conditions.and')}
        <a
          href={policyUrl}
          target="_blank"
          className="order-review__agreement--link"
          rel="noreferrer"
        >
          {t('checkout.summary.terms&conditions.policyLink')}
        </a>
      </p>
    </div>
  );
};
